import t from "../../helper/t";
import { formatDate } from "../../helper/unitsFormatting";
import { selectIpAddress, selectSpeedtestId } from "./utils";

export const getErrorClientInfo = (): string[] => {
    const speedtestId = selectSpeedtestId();
    const ipAddress = selectIpAddress();

    const date = new Date();
    
    const items = [
        speedtestId == null ? [] : [`${t("Speedtest-ID")}: ${speedtestId}`],
        speedtestId == null ? [] : [`${t("IP-Adresse")}: ${ipAddress}`],
        `${formatDate(date)} - ${date.toLocaleTimeString([], {timeStyle: "medium"})} ${t("Uhr")}`
    ].flat();

    return items;
}